import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface BackStockAgeRecordState extends ListState<any>
{
}

class BackStockAgeMutations extends ListMutations<BackStockAgeRecordState>
{

}
class BackStockAgeRecord extends ListModule<BackStockAgeRecordState, any, any>
{
    state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<any>(),
    loading: false,
}
        actions = {
            async getAll(context: ActionContext<BackStockAgeRecordState, any>
            , payload: any) {
            context.state.loading = true;
                let reponse = await Ajax.get('/api/services/app/StockAgeRule/GetRecordList', { params: payload.data });
                context.state.loading = false;
                let page = reponse.data.result as PageResult<any>;
                context.state.totalCount = page.totalCount;
                context.state.list = page.items;
                },
            };
                        mutations = {
                            setCurrentPage(state: BackStockAgeRecordState, page: number) {
                        state.currentPage = page;
                        },
                            setPageSize(state: BackStockAgeRecordState, pagesize: number) {
                        state.pageSize = pagesize;
                        }
                        }
                        }

const backStockAgeRecord = new BackStockAgeRecord();
export default backStockAgeRecord;
